import React from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import { SuccessIcon } from 'assets/icons';
import { Container } from './styles';

const ModalGeneralSuccessfully = ({
  isOpen,
  setIsOpen,
  amount,
  cardNumber,
  role,
  fullName,
  setAmount,
  setDetails,
  newNetworkName,
  newWifiPassword,
  callback,
  type
}) => {

  const closeModal = () => {
    if(callback) {
      callback()
    }
    if(setAmount) {
      setAmount('')
    }
    if(setDetails) {
      setDetails('')
    }
    setIsOpen(false)
  }

  const getTitle = (type) => {
    let title;
    switch (type) {
      case "reset-wifi":
        title = "Reset Wi-Fi Access";
        break;
      case "invalidate-wifi":
        title = "Invalidate Wi-Fi Access";
        break;
      case "checkInPayment":
        title = "Payment Completed";
        break;
    default:
        title = "";
    }
    return title;
  }

  const getMessage = (type, amount, cardNumber, fullName, role) =>{
    let message;
    const formattedAmount = Number(amount).toFixed(2);
    const last4 = cardNumber?.slice(-4);

    switch (type) {
      case "reset-wifi":
        message = "Here are the new Wi-Fi credentials. Please share them securely with the guest.";
        break;
      case "invalidate-wifi":
        message = "The current Wi-Fi credentials have been successfully invalidated.";
        break;
      case "checkInPayment":
        message = "The payment has been successfully processed.";
        break;
      case "onlyAddChargeToBill":
        message = `You have successfully added a charge of $${formattedAmount} to the bill.`;
        break;

      case "retry":
        message = `Transaction retry succeeded against card ending in ${last4}`;
        break;

      case "coupon":
        message = `Coupon code applied successfully.`;
        break;

      case "void":
        message = `You have successfully voided the $${formattedAmount} transaction of the card ending in ${last4}.`;
        break;

      case "settlement":
        message =
          "The payment has been processed successfully. Any remaining hold on this customer’s card has been released.";
        break;

      case "createStaff":
        message = `You have successfully added ${fullName} as a ${role}.`;
        break;

      default:
        message = `The ${type} of $${formattedAmount} to the card ending in ${last4} has been successfully processed.`;
    }

    return message;
  }

  const getSecondaryMessage = (type, newNetworkName) => {
    let secondaryMessage;
    switch (type) {
      case "reset-wifi":
        secondaryMessage = `Wifi Network Name: ${newNetworkName}`;
        break;
      default:
        secondaryMessage = "";
    }
    return secondaryMessage;
  }

  const getTertiaryMessage = (type, newWifiPassword) => {
    let tertiaryMessage;
    switch (type) {
      case "reset-wifi":
        tertiaryMessage = `Wifi Password: ${newWifiPassword}`;
        break;
      default:
        tertiaryMessage = "";
    } 
    return tertiaryMessage;
  }

  const title = getTitle(type);
  const message = getMessage(type, amount, cardNumber, fullName, role);
  const secondaryMessage = getSecondaryMessage(type, newNetworkName);
  const tertiaryMessage = getTertiaryMessage(type, newWifiPassword);

  return (
    <MainModal
      isOpen={isOpen}
      setClose={closeModal}
      className="modal-success"
      additionalstyle={`
        max-width: 500px;
        .modal-content{
          height: 100%;
          .close {
            z-index: 200;
          }   
          .modal-body{
            height: 100%;
            padding: 24px;
          }
        }
        top: 179px;
      `}
    >
      <Container>
        <SuccessIcon />
        {title && <div className="title">{title}</div>}
        <div className="text">{message}</div>
        {secondaryMessage && <div className="text">
          <span>{secondaryMessage}</span>
          <span>{tertiaryMessage}</span>
        </div>}
        <Button
          success
          onClick={closeModal}
          additionalstyle={`
            width: 116px;
            margin-top: 24px;
          `}
        >
          OK
        </Button>
      </Container>
    </MainModal>
  );
}

export default ModalGeneralSuccessfully;
